module.exports = "/static/assets/22e1fb45c852ab96fc6eb36c510ab498.gif";